import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ValidationMessageResolver } from '@ngx-strakit/validation';
import { VALID_ALIAS_VALIDATOR_NAME, VALID_ALIAS_VALIDATOR_TRANSLATION_KEY } from '@iris/common/modules/fields/validation/validators/valid-alias.validator';

@Injectable()
export class SkValidAliasValidationMessageResolver implements ValidationMessageResolver {
  private readonly translate = inject(TranslateService);

  readonly errorCode = VALID_ALIAS_VALIDATOR_NAME;

  getMessage(): string {
    return this.translate.instant(VALID_ALIAS_VALIDATOR_TRANSLATION_KEY);
  }
}
